import React from "react";
import Hero from "./Hero";
import Interesting from "./Interesting";

const Class01Details = () => {
    return (
        <>
            <Hero />
            <Interesting />
        </>
    );
};

export default Class01Details;
